import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["ruleType", "trigger", "actionParams"];

  updateTriggerOptions() {
    const type = this.ruleTypeTarget.value;
    const select = this.triggerTarget;
    const options = JSON.parse(select.dataset.options)[type] || [];

    // clear all the existing <option> elements
    select.innerHTML = "";

    options.forEach((option) => {
      let element = document.createElement("option");
      element.value = option;
      element.textContent = option;
      select.appendChild(element);
    });

    this.updateTemplate();
  }

  updateTemplate() {
    const type = this.ruleTypeTarget.value;
    const trigger = this.triggerTarget.value;
    const examples = JSON.parse(this.actionParamsTarget.dataset.examples);
    const example = (examples[type] && examples[type][trigger]) || [];

    this.actionParamsTarget.value = JSON.stringify(example, null, 2);
  }
}
